import moment from 'moment';
import { DoctorService } from '@/services/doctor.service';
export default {
  props: {
    rowData: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      showDialog: false,
      buttonDisabled: false,
      alert: {
        show: false,
        message: ''
      }
    };
  },
  computed: {
    doctors() {
      return this.rowData.doctorlistdetails || [];
    },
    currentEndDateLabel() {
      if (!this.rowData.enddatestamp) {
        return '—';
      }
      return moment(this.rowData.enddatestamp * 1000).format('MM/DD/YYYY LTS');
    }
  },
  watch: {
    async showDialog(show) {
      if (show) {
        await this.$nextTick();
        this.$refs.cancelBtn.focus();
      }
    }
  },
  methods: {
    async confirmConvert() {
      if (this.buttonDisabled) {
        return;
      }
      this.buttonDisabled = true;
      try {
        await DoctorService.convertReassignmentToPermanent(this.rowData.id);
        this.$emit('show-toast', 'Reassignment converted to permanent successfully!');
        this.$emit('refresh');
        this.showDialog = false;
      } catch (e) {
        this.alert = {
          show: true,
          message: 'Unable to convert this reassignment to permanent. Please try again.'
        };
      } finally {
        this.buttonDisabled = false;
      }
    },
    onHide() {
      this.alert = {
        show: false,
        message: ''
      };
      this.buttonDisabled = false;
    }
  }
};